// extracted by mini-css-extract-plugin
export default {"page":"request-demo_page__MIEiE","_footer":"request-demo__footer__IA0z3"};